module.exports = __webpack_public_path__ + "static/media/mi2.8177df93.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mi2.png
// module id = 310
// module chunks = 0